/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-14 18:47:47
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-14 18:47:48
 * @FilePath: /privacy-web/src/utils/common.js
 */
export const isElementNotInViewport = function(el) {
	if (el) {
		let rect = el.getBoundingClientRect();
		return (
			rect.top >=
				(window.innerHeight || document.documentElement.clientHeight) ||
			rect.bottom <= 0
		);
	}
};